import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetPostingsParams, IPostingsApiResponse } from './types';

async function getPostings(
  params: IGetPostingsParams,
): Promise<IPostingsApiResponse> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IPostingsApiResponse>(
    '/posting-service/postings',
    {
      headers,
      params: {
        page: params.page || 1,
        pageSize: params.limit || 15,
        status: params.status,
      },
    },
  );

  return response.data;
}

export const postingsApi = {
  getPostings,
};
